import "./ProjectHeroBandSite.scss";

function ProjectHeroBandSite() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">BandSite</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              This is a fully responsive website for a trendy band group.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://supreet-kaur-bandsite.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroBandSite;
